export const policiesVersion = 1; //update this number when updating policies

export const TOS_MD =
  "https://raw.githubusercontent.com/euler-xyz/euler-docs/20240826-updated-legal-pages/legal/termsOfUse-20240828.md"
export const PRIVACY_POLICY_MD =
  "https://raw.githubusercontent.com/euler-xyz/euler-docs/20240826-updated-legal-pages/legal/privacyPolicy-20240828.md"
export const RISK_DISCLOSURES_MD =
  "https://raw.githubusercontent.com/euler-xyz/euler-docs/20240826-updated-legal-pages/legal/riskDisclosures-20240828.md"